import type { Disposable } from '@patsnap/tahiti-core';
import type { Config, Driver } from 'driver.js';

/** 各 onboarding 模块共享的浏览器基础能力。 */
export interface OnboardingBrowserRuntime {
    /** 读取本地存储。 */
    getStorageItem(key: string): string | null;
    /** 写入本地存储。 */
    setStorageItem(key: string, value: string): void;
    /** 创建 Driver.js 实例。 */
    createDriver(config: Config): Driver;
    /** 锁定指定容器的纵向滚动，并返回恢复原始状态的清理句柄。 */
    lockVerticalScroll(element: Element): Disposable;
    /** 等待 Vue 完成本轮渲染。 */
    waitForRender(): Promise<unknown>;
    /** 在限定时间内等待异步目标出现。 */
    waitForElement(selector: string, timeoutMs: number): Promise<Element | null>;
    /** 查询目标元素。 */
    querySelector(selector: string): Element | null;
    /** 创建 DOM 元素。 */
    createElement(tagName: string): HTMLElement;
    /** 创建浏览器定时器。 */
    setTimeout(callback: () => void, timeoutMs: number): number;
    /** 清理浏览器定时器。 */
    clearTimeout(timeoutId: number): void;
    /** 注册 DOM 事件。 */
    addEventListener(element: Element | Document, type: string, listener: EventListener): void;
    /** 移除 DOM 事件。 */
    removeEventListener(element: Element | Document, type: string, listener: EventListener): void;
    /** 注册 document 全局事件。 */
    addDocumentEventListener(type: string, listener: EventListener): void;
    /** 移除 document 全局事件。 */
    removeDocumentEventListener(type: string, listener: EventListener): void;
    /** 计算滚动容器的阅读进度。 */
    getReadingProgress(element: Element): number;
    /** 添加样式类。 */
    addClass(element: Element, className: string): void;
    /** 移除样式类。 */
    removeClass(element: Element, className: string): void;
    /** 判断目标是否可交互。 */
    isElementEnabled(element: Element): boolean;
    /** 记录可安全降级的异常。 */
    warn(message: string, error: unknown): void;
}

/** Onboarding 浏览器基础能力的容器标识。 */
export const OnboardingBrowserRuntime = Symbol('OnboardingBrowserRuntime');
